import { FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button} from "@mui/material";
import React, { useEffect, useState } from "react";
import Search from "../../../components/common/search/Search";
import Input from "../../../components/common/input/Input";
import { useDispatch, useSelector } from "react-redux";
import { userApiLoader } from "../../../action/loaderActions";
import API from "../../../config/apiconfig";
import axiosInstance from "../../../utils/axios/axiosInstance";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";

const Medicalappointmenttab = () => {
    const dispatch = useDispatch();
    const {UserId} = useSelector(state => state.user);
    const [statusFilter, setStatusFilter] = useState(""); 
    const [isAppoinments,setIsAppoinments] = useState([]);
    const [appointmentName, setAppointmentName] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [doctor, setDoctor] = useState('');
    const [reason, setReason] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editingAppointmentId, setEditingAppointmentId] = useState(null);


    useEffect(() => {
        const date = new Date().toISOString().split('T')[0];
        setDate(date);
        const time = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
        setTime(time);
    }, []);
    
    const filteredAppointments = statusFilter
        ? isAppoinments.filter(appointment => appointment.status === statusFilter)
        : isAppoinments;

    const handleFilterChange = (event) => {
        setStatusFilter(event.target.value); 
    };

    const getAppoinmnetList= () =>{
        dispatch(userApiLoader({isApiLoader: true}));
        axiosInstance.get(
            `${API.USER_MANAGEMENT_API_BASE_URL}${API.HEALTH_TRACKER}${API.GET_APPOINMENTS}`
        )
        .then((res) => {
            console.log(res?.data);
            setIsAppoinments(res?.data?.appointments);
            dispatch(userApiLoader({isApiLoader: false}));
        })
        .catch((err) => {
            console.log(err);
            dispatch(userApiLoader({isApiLoader: false}));
        })
    }

    const CreateAppoinment = () => {
        dispatch(userApiLoader({isApiLoader: true}));
        const formattedTime = new Date(`1970-01-01T${time}:00`).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    
        const requestBody = {
            student_id: UserId,
            appointment_name: appointmentName,
            date: date,
            time: formattedTime,
            doctor: doctor,
            reason: reason,
        };
    
        console.log(requestBody);
        axiosInstance.post(
            `${API.USER_MANAGEMENT_API_BASE_URL}${API.HEALTH_TRACKER}${API.GET_APPOINMENTS}`,
            requestBody
        )
        .then((res) => {
            console.log(res?.data);
            dispatch(userApiLoader({isApiLoader: false}));
            toast.success(res?.data?.message, {
                autoClose: 6000,
            });
            setAppointmentName('');
            setDate('');
            setTime('');
            setDoctor('');
            setReason('');
            getAppoinmnetList();
        })
        .catch((err) => {
            console.log(err);
            dispatch(userApiLoader({isApiLoader: false}));
            toast.error(err?.data?.message || "Something went wrong", {
                autoClose: 6000,
            });
        });
    }
   
    useEffect(() =>{
        getAppoinmnetList();
    },[]);

    const handleEdit = (appointment) => {
        setAppointmentName(appointment.appointment_name);
        setDate(appointment.date);
        setTime(appointment.time);
        setDoctor(appointment.doctor);
        setReason(appointment.reason);
        setIsEditing(true);
        setEditingAppointmentId(appointment.appointment_id);
    };

    const UpdateAppointment = () => {
        dispatch(userApiLoader({isApiLoader: true}));
        const formattedTime = new Date(`1970-01-01T${time}:00`).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    
        const requestBody = {
            student_id: UserId,
            appointment_name: appointmentName,
            date: date,
            time: formattedTime,
            doctor: doctor,
            reason: reason,
            appointment_id: editingAppointmentId
        };

        axiosInstance.put(
            `${API.USER_MANAGEMENT_API_BASE_URL}${API.HEALTH_TRACKER}${API.GET_APPOINMENTS}`,
            requestBody
        )
        .then((res) => {
            dispatch(userApiLoader({isApiLoader: false}));
            toast.success(res?.data?.message, { autoClose: 6000 });
            clearForm();
            setIsEditing(false);
            setEditingAppointmentId(null);
            getAppoinmnetList();
        })
        .catch((err) => {
            console.log(err);
            toast.error("Failed to update appointment", { autoClose: 6000 });
            dispatch(userApiLoader({isApiLoader: false}));
        });
    };
    
    const clearForm = () => {
        setAppointmentName('');
        setDate(new Date().toISOString().split('T')[0]);
        setTime(new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }));
        setDoctor('');
        setReason('');
    };
    
    const deleteAppoinment = (appointment) => {
        dispatch(userApiLoader({isApiLoader: true}));
        axiosInstance.delete(
            `${API.USER_MANAGEMENT_API_BASE_URL}${API.HEALTH_TRACKER}${API.GET_APPOINMENTS}/${appointment.appointment_id}`,
        )
        .then((res) => {
            dispatch(userApiLoader({isApiLoader: false}));
            toast.success(res?.data?.message, { autoClose: 6000 });
            getAppoinmnetList();
        })
        .catch((err) => {
            console.log(err);
            toast.error(err?.data?.message, { autoClose: 6000 });
            dispatch(userApiLoader({isApiLoader: false}));
        });
    }
    

    return (
        <Grid container spacing={2} style={{ padding: "0px !important" }} className="max-h-[calc(100vh-210px)] overflow-y-auto">
            <Grid item xs={12} lg={4}>
                <Paper elevation={3} className="p-5 relative">
                    <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">
                        Create Appointment
                    </Typography>
                    <div className="flex flex-col mt-5 gap-2">
                        <Input placeholder="Appointment Name" defaultValue={appointmentName} onChange={(e) => setAppointmentName(e.target.value)} />
                        <Input type="date" defaultValue={date} onChange={(e) => setDate(e.target.value)} />
                        <Input type="time" defaultValue={time} onChange={(e) => setTime(e.target.value)} />
                        <Input placeholder="Doctor Name" defaultValue={doctor} onChange={(e) => setDoctor(e.target.value)} />
                        <Input placeholder="Reason" defaultValue={reason} onChange={(e) => setReason(e.target.value)} />
                        <div className="mt-10">
                            {isEditing ? (
                                <Button variant="contained" color="primary" onClick={UpdateAppointment}>
                                    Update
                                </Button>
                            ) : (
                                <Button variant="contained" color="primary" onClick={CreateAppoinment}>
                                    Create
                                </Button>
                            )}
                        </div>
                    </div>
                </Paper>
            </Grid>

            <Grid item xs={12} lg={8} className="h-full">
                <Paper elevation={3} className="p-5 relative">
                    <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">
                        Medical Appointment
                    </Typography>
                    <Grid container spacing={2} alignItems="center" display="flex" justifyContent="space-between" className="!my-2">
                        <Grid item xs={12} lg={6} justifyContent="flex-start">
                            <Search />
                        </Grid>
                        <Grid item xs={12} lg={6} display="flex" justifyContent="flex-end">
                            <FormControl variant="outlined" size="small" fullWidth className="!max-w-[200px]">
                                <InputLabel className="text-sm font-medium text-gray-800 block">
                                    Filter
                                </InputLabel>
                                <Select 
                                    value={statusFilter} 
                                    onChange={handleFilterChange} 
                                    label="Status" 
                                >
                                    <MenuItem value="">All</MenuItem> 
                                    <MenuItem value="Confirmed">Confirmed</MenuItem>
                                    <MenuItem value="Pending">Pending</MenuItem>
                                    <MenuItem value="Canceled">Canceled</MenuItem>
                                    <MenuItem value="Completed">Completed</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} elevation={3} className="!mt-5">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Appointment Name</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Time</TableCell>
                                    <TableCell>Doctor Name</TableCell>
                                    {/* <TableCell>Status</TableCell> */}
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredAppointments.map((appointment) => (
                                    <TableRow key={appointment.appointment_id}>
                                        <TableCell>{appointment.appointment_name}</TableCell>
                                        <TableCell>{appointment.date}</TableCell>
                                        <TableCell>{appointment.time}</TableCell>
                                        <TableCell>{appointment.doctor}</TableCell>
                                        {/* <TableCell>
                                            <span
                                                style={{
                                                    color:
                                                        appointment.status === "Confirmed"
                                                            ? "green"
                                                            : appointment.status === "Pending"
                                                            ? "orange"
                                                            : appointment.status === "Canceled"
                                                            ? "red"
                                                            : "blue",
                                                }}
                                            >
                                                {appointment.status}
                                            </span>
                                        </TableCell> */}
                                        <TableCell align="center">
                                            <div className="flex items-center gap-5">
                                                <div className="border border-gray-200 p-1 rounded-md cursor-pointer" onClick={() => handleEdit(appointment)}>
                                                    <Edit color="primary" fontSize="small"/>
                                                </div>
                                                <div className="border border-gray-200 p-1 rounded-md cursor-pointer" onClick={() => deleteAppoinment(appointment)}>
                                                    <Delete color="primary" fontSize="small"/>
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Medicalappointmenttab;
